import React from 'react';
import MarketServiceGenericService from "./MarketServiceGenericService";

function AccountTypeService() {
    const endpointUrl = `${process.env.REACT_APP_EDP_API_BASE_URL}/accountType/`
    return (<MarketServiceGenericService
        endpointUrl={endpointUrl}
        pageName={"Account Type Service"}
    />);
}

export default AccountTypeService;